export default[
    {
        path: '/data/shopRecharge',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '充值额度申请',
            authLogin: true
        }
    }, 
    {
        path: '/data/shopRecharge/edit',
        component: resolve => require(['../edit.vue'], resolve),
        meta: {
            title: '新增充值额度'
        }
    }
]